import React, { useState } from 'react';
import AppBar from "@mui/material/AppBar";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ResumenComponentes from './ResumenComponentes';
import Mtable_Componentes from './Mtable_Componentes';


const MainComponente = () => {
    const idCompania = localStorage.getItem("idcompania");
    const [value, setValue] = useState(0);

    // Definir las compañías que pueden ver Módulos
    const companiasModulos = ["1", "8", "5", "13", "14"];
    const puedeVerModulos = companiasModulos.includes(idCompania);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <AppBar position="static" style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}>
                <Tabs value={value} onChange={handleChange}>
                    <Tab label="Aplicaciones" style={{ color: "#ffffff", padding: "3px 7px 3px" }} />
                    <Tab label="Resumen" style={{ color: "#ffffff", padding: "3px 7px 3px" }} />
                    {puedeVerModulos && (
                        <Tab label="Módulos" style={{ color: "#ffffff", padding: "3px 7px 3px" }} />
                    )}

                </Tabs>
            </AppBar>

            {value === 0 && <Mtable_Componentes value={1} />}
            {value === 1 && <ResumenComponentes />}
            {value === 2 && puedeVerModulos && <Mtable_Componentes value={2} />}


        </div>
    );
};

export default MainComponente;
